<template>
<div class="panel" id="latest-matches-panel">
    <div class="panel-title">
      Les derniers matchs
        <hr>
    </div>
    <div class="panel-content">
        <div class="row columns">
        </div>
        <div class="" v-if="mrList && mrList.length > 0" v-for="report in mrList">
            <div class="match-panel row columns align-middle lose">
                <div class="row columns align-middle lose" :id="report.id" @click="gotoDetail(report.id)">
                    <div class="large-2 columns"><img class="small-team-icon" :src="getRosterIcon(report.home_report.roster)" alt="team"></div>
                    <div class="large-8 columns ">{{report.home_report.team.name}}</div>
                    <div class="large-1 columns text-centered">{{report.home_report.nb_td}}</div>
                </div>
                <div class="row columns win">
                    <div class="large-2 columns"><img class="small-team-icon" :src="getRosterIcon(report.visitor_report.roster)" alt="team"></div>
                    <div class="large-8 columns ">{{report.visitor_report.team.name}}</div>
                    <div class="large-1 columns text-centered">{{report.visitor_report.nb_td}}</div>
                </div>
            </div>
        </div>
        <div class="row columns">
            <router-link :to="{ name:'matchReportList'}" class="bottom-link">Tous les matchs...</router-link>
        </div>
    </div>
</div>
</template>

<script>
// import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'

export default {
  name: 'latestMatchesPanel',
  computed: {
    ...mapGetters([
      'filteredMatchReportList'
    ]),
    mrList: function () {
      return this.filteredMatchReportList
    }
  },
  methods: {
    getRosterIcon (roster) {
      return '/static/imgs/team-icons/' + roster.replace(/\s+/, '') + '.png'
    },
    gotoDetail (id) {
      this.$router.push({name: 'matchReportDetail', params: { id: id.toString() }})
    }
  },
  created () {
    store.dispatch('invalidatMatchReportList')
    store.dispatch('getPublishedMatchReport', 8)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.match-panel{
    font-weight: 300;
    font-size: 0.8rem;
}

div.match-panel {
    margin-bottom: 0.4rem;
}

div.match-panel div.row{
    background-color: #E9EDEF;
    padding: 0.4rem 0rem;
    transition: background-color 0.15s;
    cursor: pointer;
}

.match-panel:hover div.row{
    background-color: #ACB5C3
}

.small-team-icon {
    width: 25px;
    height: 25px;
    padding-right: 0;
    padding-left: 0;
    max-width: none;
}
</style>



// WEBPACK FOOTER //
// latest-matches-panel.vue?5685fc9d